import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "memeber-profile"
};
var _hoisted_2 = {
  "class": "memeber-profile-main"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  "class": "list"
};
var _hoisted_5 = {
  "class": "memeber-profile-footer"
};
var _hoisted_6 = {
  key: 1,
  "class": "edit-h5"
};
var _hoisted_7 = {
  "class": "main"
};
var _hoisted_8 = {
  "class": "edit-h5-header"
};
var _hoisted_9 = {
  "class": "left"
};
var _hoisted_10 = {
  "class": "memeber-profile"
};
var _hoisted_11 = {
  "class": "memeber-profile-main"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  "class": "list"
};
var _hoisted_14 = {
  "class": "memeber-profile-footer"
};
import TUIChatEngine, { TUITranslateService, TUIUserService, TUIConversationService, TUIFriendService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref, watch, watchEffect } from "../../../adapter-vue";
import { isUniFrameWork } from "../../../utils/env";
import { TUIGlobal } from "../../../utils/universal-api";
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-profile',
  props: {
    userInfo: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["handleSwitchConversation", "close", "openConversation"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var isFriendShip = ref(false);
    var userInfoManager = ref({});
    watchEffect(function () {
      userInfoManager.value = props.userInfo;
    });
    var emits = __emit;
    watch(function () {
      return props.userInfo;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(newVal, oldVal) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(newVal === oldVal)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return TUIUserService.getUserProfile({
                userIDList: [props.userInfo.userID]
              });
            case 4:
              res = _context.sent;
              userInfoManager.value = res === null || res === void 0 ? void 0 : res.data[0];
              // 这里需要确认是否是好友关系
              checkFriend();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      deep: true,
      immediate: true
    });
    var enter = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ID, type) {
        var name;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              name = "".concat(type).concat(ID);
              TUIConversationService.getConversationProfile(name).then(function (res) {
                TUIConversationService.switchConversation(res.data.conversation.conversationID).then(function () {
                  TUIStore.update(StoreName.GRP, "isShowManageComponent", false);
                  if (isUniFrameWork) {
                    TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.navigateBack();
                  }
                });
              })["catch"](function (err) {
                console.warn("获取会话资料失败", err.code, err.msg);
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function enter(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    var checkFriend = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (userInfoManager.value.userID) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              TUIFriendService.checkFriend({
                userIDList: [userInfoManager.value.userID],
                type: TUIChatEngine.TYPES.SNS_CHECK_TYPE_BOTH
              }).then(function (res) {
                var _res$data;
                var relation = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.successUserIDList) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.relation;
                isFriendShip.value = relation === TUIChatEngine.TYPES.SNS_TYPE_BOTH_WAY;
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function checkFriend() {
        return _ref4.apply(this, arguments);
      };
    }();
    var showEnter = function showEnter() {
      return isFriendShip.value || !TUIStore.getData(StoreName.APP, "isOfficial");
    };
    var close = function close(tabName) {
      emits("close", tabName);
    };
    return function (_ctx, _cache) {
      return !_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        "class": "avatar",
        src: _unref(userInfoManager).avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
        onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 8, _hoisted_3), _createElementVNode("ul", _hoisted_4, [_createElementVNode("h2", null, _toDisplayString(_unref(userInfoManager).nick || _unref(userInfoManager).userID), 1), _createElementVNode("li", null, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "ID：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).userID), 1)]), _createElementVNode("li", null, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.个性签名")) + "：", 1), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).selfSignature), 1)])])]), _createElementVNode("div", _hoisted_5, [showEnter() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "button",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return enter(_unref(userInfoManager).userID, 'C2C');
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.发送消息")), 1)) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("main", _hoisted_7, [_createElementVNode("header", _hoisted_8, [_createElementVNode("aside", _hoisted_9, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u6210\u5458")), 1)]), _createElementVNode("span", {
        "class": "close",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return close('profile');
        })
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        "class": "avatar",
        src: _unref(userInfoManager).avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
        onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 8, _hoisted_12), _createElementVNode("ul", _hoisted_13, [_createElementVNode("h1", null, _toDisplayString(_unref(userInfoManager).nick || _unref(userInfoManager).userID), 1), _createElementVNode("li", null, [_cache[4] || (_cache[4] = _createElementVNode("label", null, "ID：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).userID), 1)]), _createElementVNode("li", null, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIContact.个性签名")) + "：", 1), _createElementVNode("span", null, _toDisplayString(_unref(userInfoManager).selfSignature), 1)])])]), _createElementVNode("div", _hoisted_14, [showEnter() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "button",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return enter(_unref(userInfoManager).userID, 'C2C');
        })
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.发送消息")), 1)) : _createCommentVNode("", true)])])])]));
    };
  }
});